import { render } from "./Zhishu.vue?vue&type=template&id=0899b593&scoped=true&ts=true"
import script from "./Zhishu.vue?vue&type=script&setup=true&lang=ts"
export * from "./Zhishu.vue?vue&type=script&setup=true&lang=ts"

import "./Zhishu.vue?vue&type=style&index=0&id=0899b593&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0899b593"],['__file',"src/components/player/Zhishu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0899b593"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0899b593', __exports__)) {
    console.log('reload')
    api.reload('0899b593', __exports__)
  }
  
  module.hot.accept("./Zhishu.vue?vue&type=template&id=0899b593&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0899b593', render)
  })

}


export default __exports__